import { captureException, withScope } from '@/utils/asyncSentry'

/**
 * @param {Scope} scope
 * @param {('setExtra'|'setTag')} prop
 * @param {*} value
 */
const setParam = (scope, prop, value) => {
  // break early
  if (value == null) return

  if (value instanceof Function) {
    value(scope)
  } else if (Array.isArray(value)) {
    captureException(new Error(`captureExceptionWithTags does not support array for ${prop}`))
  } else if (value instanceof Object) {
    scope[`${prop}s`](value)
  } else {
    scope[prop]('extra', value)
  }
}

/**
 *
 * @param {Error} exception
 * @param {Object} extended
 * @param {*|Object.<string, any>|function(scope: Scope)} [extended.extra]
 * @param {('fatal'|'error'|'warning'|'log'|'info'|'debug'|'critical')} [extended.severity='error']
 * @param {(string|Object.<string, string>|function(scope: Scope))} [extended.tags]
 */
export const captureExtendedException = (
  exception, {
    extra,
    severity = 'error',
    tags
  } = {}
) => {
  withScope(function (scope) {
    scope.setLevel(severity)
    setParam(scope, 'setExtra', extra)
    setParam(scope, 'setTag', tags)
    captureException(exception)
  })
}

export const assertInMap = (key, map, msg, scopeTags) => {
  if ((key in map)) return true
  captureExtendedException(new Error(msg), scopeTags)
  return false
}
